import React from "react";
import { BookOpen } from "lucide-react";
import { Reveal, SectionLabel, SerifHeading } from "@/components/site/primitives";
import { PUBLICATIONS } from "@/lib/site-data";

export default function PublicationsPage() {
  return (
    <div data-testid="page-publications" className="pt-32 md:pt-40 pb-24">
      <div className="mx-auto max-w-[1400px] px-6 md:px-10">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 items-end">
          <div className="lg:col-span-7">
            <SectionLabel>Publications</SectionLabel>
            <SerifHeading className="mt-6">
              Selected legal research papers.
            </SerifHeading>
          </div>
          <div className="lg:col-span-5">
            <p className="text-muted-foreground leading-relaxed">
              A record of published legal research spanning criminal justice,
              constitutional issues, and human-rights jurisprudence.
            </p>
          </div>
        </div>

        <div className="mt-16 grid grid-cols-1 md:grid-cols-2 gap-px bg-border border border-border">
          {PUBLICATIONS.map((p, idx) => (
            <Reveal key={p.title} delay={idx * 0.06}>
              <article
                data-testid={`publication-${idx}`}
                className="bg-white p-8 md:p-12 h-full flex flex-col justify-between min-h-[260px] group hover:bg-[#FAFAFA] transition-colors"
              >
                <div>
                  <div className="flex items-center gap-3">
                    <BookOpen size={16} className="text-gold" />
                    <span className="eyebrow text-[#B8912C]">{p.kind}</span>
                  </div>
                  <h3 className="mt-8 font-serif text-2xl md:text-3xl text-navy leading-tight">
                    {p.title}
                  </h3>
                </div>
                <div className="mt-10 flex items-center justify-between">
                  <span className="text-xs uppercase tracking-[0.22em] text-navy/60">
                    Paper {String(idx + 1).padStart(2, "0")}
                  </span>
                  <span className="h-px w-16 bg-gold transition-all group-hover:w-24" />
                </div>
              </article>
            </Reveal>
          ))}
        </div>
      </div>
    </div>
  );
}
